import { useState, useEffect } from 'react';

const navItems = [
  { label: '热门专题', href: '#carousel' },
  { label: '平台特色', href: '#features' },
  { label: '关于午马', href: '#about' },
  { label: '精选剧集', href: '#cards' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-lg shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            className="flex items-center gap-2.5 no-underline group"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-500 rounded-lg flex items-center justify-center transition-transform group-hover:scale-105">
              <i className="ri-movie-2-fill text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">
              午马影院
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg transition-colors whitespace-nowrap"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#ranking"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              立即追剧
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 py-4 flex flex-col gap-1 animate-in fade-in slide-in-from-top-2 duration-200">
            <a
              href="#hero"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#ranking"
              onClick={() => setMobileOpen(false)}
              className="mx-4 mt-2 px-5 py-2.5 text-sm font-medium text-center text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              立即追剧
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}